{
  "main": {
    "title": "Aircraft Directory",
    "nazaj": "Back"
  },
  "navs": {
    "vnos": "Entry",
    "seznam": "List",
    "modal": {
      "pregled": "Overview",
      "servisna": "Service manual"
    }
  },
  "table": {
    "registracija": "Registration",
    "tip": "Type",
    "vrsta": "Category",
    "podrobno": "details",
    "s_ure": "Total hours",
    "s_letov": "Total Flights"
  },
  "modal": {
    "vlecno": "Tow plane:",
    "obracun_servis": "Recording \"Flight\" Time:",
    "razpolozljivo": "Visible in availability:",
    "camo_pregled": "Visible in the Camo overview:",
    "camo_flight": "Displaying “Flight” time in CAMO:",
    "tip": "Type:",
    "model": "Model:",
    "serijska": "Serial:",
    "masa_plovila": "Weight of aircraft:",
    "klub": "Club:",
    "stUr": "Number of hours:",
    "stSUr": "Clock readings:",
    "stLetov": "Number of initial flights:",
    "vrsta": "Aircraft category:",
    "datumN": "Purchase date:",
    "datumR": "Registration date:",
    "opombaJ": "Glider note:",
    "datumV": "Entry date:",
    "servis": {
      "stSUr": "Clock readings:",
      "stLetov": "Flight Status:",
      "interval": "Service interval: ",
      "datum_zServis": "Date of last service: ",
      "opravljen_servis": "Service performed at:",
      "naslednji_servis": "Next service: ",
      "status": "Status: ",
      "plovnost": "Is the plane airworthy?",
      "plovnost_opomba": "Note on why the airplane is not airworthy:"
    },
    "wb": {
      "minCG": "Min. C.G. ({enota}):",
      "maxCG": "Max. C.G. ({enota}):",
      "mTeza": "MTOW ({enota}):",
      "mGorivo": "Fuel ({enota}):",
      "pTeza": "Empty aircraft ({enota}):",
      "tPilot": "Pilot & Front passenger ({enota}):",
      "tPotniki": "Rear passenger(s) ({enota}):",
      "tPrtljaga": "Baggage ({enota}):",
      "maxGorivo": "Max. fuel quantity ({enota}):",
      "maxPrtljaga": "Max. baggage weight ({enota}):",
      "imaZadnji": "The plane has passenger seats in the back (4 seats or more)",
      "wgt": "Wgt {stevilka}:"
    }
  },
  "labels": {
    "vlecno": "Tow plane:",
    "tip": "Type:",
    "model": "Model:",
    "serijska": "Serial:",
    "masa_plovila_edit": "Vessel Weight ({enota}):",
    "klub": "Select club:",
    "stUr": "Number of hours:",
    "stLetov": "Number of flights:",
    "vrsta": "Select category:",
    "datumN": "Purchase date:",
    "datumR": "Registration date:",
    "opombaJ": "Glider note:",
    "opomba": "Note:",
    "komponenta": {
      "ime": "Ime komponente",
      "servis_interval": "Servisni interval:",
      "zadnji_servis": "Service performed at:",
      "naslednji_servis": "Next service:",
      "servis_opravljen": "Date of last service:"
    },
    "obracunStevec": "Recording 'Flight' Time:",
    "razpolozljivo": "Visible in availability:",
    "camo_pregled": "Show in CAMO:",
    "doServisa": "Number of hours until service: "
  },
  "buttons": {
    "uredi": "Edit data",
    "posodobi": "Update data",
    "brisi": "Delete aircraft",
    "brisiIzbiro": "Clear selection",
    "csv": "Export to CSV",
    "servis": {
      "uredi": "Uredi servisne podatke",
      "posodobi": "Posodobi servisne podatke"
    },
    "dodajKomponento": "Add a component"
  }
}